import { REDIRECT_KEY } from '../../constents/text';
import { GOOGLE_AUTH_API } from '../../Utils/apis';

const useGoogleLogin = () => {

    return async () => {

        try {
            window.location.href = GOOGLE_AUTH_API + `?state=${(window.sessionStorage.getItem(REDIRECT_KEY) ? window.sessionStorage.getItem(REDIRECT_KEY) : '/dashboard')}`;
            // console.log(document.cookie);
        } catch (err) {
            // console.log(err);
        } finally {
        }
    }
}

export default useGoogleLogin;
